import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { FormControl, TextField, Autocomplete } from "@material-ui/core";
import {
  DataSheetGrid,
  textColumn,
  keyColumn,
  intColumn,
  floatColumn,
} from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";
// import { makeStyles } from "@material-ui/styles";
import POAlertDialog from "./PoTableAlert";
import {
  getCostCenterDataForExcel,
  getCostCenterData_v2,
  getEmployeeByCostCenter,
  getEmployeeByCostCenter_IP,
  getg_laccountForExcel,
  getg_laccount_Search,
  getg_laccountForCopyPast,
  getCostCenterForCopyPast,
} from "../../actions";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import axios from "axios";

import "./style.css";
import { addZeroes } from "../../../../Functions";

import $ from "jquery";
import "select2";
import "select2/dist/css/select2.min.css";

const GL_Table_ProcessInvoice = ({
  formState,
  setFormState,
  disabled,
  setGLAccountTotal,
  importPaymentDetail,
  setImportPaymentDetail,
}) => {
  const tableData = {
    rowId: 0,
    accountId: 0,
    invoice_Id: parseInt(formState?.invoice_Id),
    glAccount: "",
    costCenter: "",
    accountType: "",
    amount: 0,
    costCenterOwner: "",
    stCode: formState?.salesTaxCode?.split(" - ")[0] || "",
    order: "",
    profitCenter: "",
    wbsElement: "",
    created_By: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    fixedAsset: "",
    tType: "",
    description: `${formState.invoice_Desc}`,
    expenseDate: "",
    horizonId: "",
    department: "",
    vendorCode: "",
  };

  const invoice_Payment_Details = {
    rowId: 0,
    inv_Payment_Id: 0,
    invoice_Id: parseInt(formState?.invoice_Id),
    postingKey: "",
    sglInd: "",
    tType: "",
    paymentTerms: "",
    paymentDays: "",
    paymentMethod: "",
    paymentMethSupp: "",
    individualPayee: true,
    account: "",
    amount: 0,
    taxAmount: 0,
    dueOn: new Date(),
    taxCode: "",
    description: "",
    order: "",
    costCenter: "",
    wbsElement: "",
    profitCenter: "",
    createdBy: "",
    createdDate: new Date(),
  };

  const [costCenterList, setCostCenterList] = useState([]);
  const [costCenterLoading, setCostCenterLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [glAccount, setGlAccount] = useState([]);
  const [loading, setLoading] = useState([]);
  const [isCostCenterDisabled, setIsCostCenterDisabled] = useState(false);
  const [costLoading, setCostLoading] = useState([]);
  const [glAccountLoading, setGlAccountLoading] = useState(false);
  const [activeCell, setActiveCell] = useState("");

  useEffect(() => {
    getCostCenterDataForExcel(
      "",
      setCostCenterLoading,
      setCostCenterList,
      setCostLoading
    );
    getg_laccountForExcel("", setLoading, setGlAccount, setGlAccountLoading);
  }, []);

  const addInput = () => {
    const num = Math.random();
    invoice_Payment_Details.rowId = num;
    invoice_Payment_Details.taxCode = formState?.salesTaxCode;
    tableData.rowId = num;
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: [...formState?.invoice_Accounts, tableData],
    }));
    if (
      (formState?.isImport && !formState?.pO_Based) ||
      (formState?.isVPPayment && !formState?.pO_Based) ||
      !formState?.pO_Based
    ) {
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: [
          ...importPaymentDetail?.invoice_Payment_Details,
          invoice_Payment_Details,
        ],
      }));
    }
  };

  const deleteInput = (index, rowId) => {
    const filteredData = formState?.invoice_Accounts?.filter(
      (x, i) => i !== index
    );
    const finded = formState?.invoice_Accounts?.find((x, i) => i !== index);
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: filteredData,
    }));

    const filteredPaymentDetail =
      importPaymentDetail?.invoice_Payment_Details?.filter(
        (x, i) => x?.rowId !== rowId
      );
    // if (formState?.isImport) {
    setImportPaymentDetail((importPaymentDetail) => ({
      ...importPaymentDetail,
      invoice_Payment_Details: filteredPaymentDetail,
    }));
    // }
    countHandler(filteredData);
  };

  const countHandler = (tempArray) => {
    let total = 0;
    for (let index = 0; index < tempArray.length; index++) {
      const item = tempArray[index];
      if (item.accountType === "Debit") {
        total = total + parseFloat(item.amount || 0);
      } else if (item.accountType === "Credit") {
        total = total - parseFloat(item.amount || 0);
      }
    }

    setGLAccountTotal(total);
  };

  const changeHandler = (e, index, item) => {
    const { name, value } = e.target;

    let tempArray = formState.invoice_Accounts;
    tempArray[index] = {
      ...formState.invoice_Accounts[index],
      [name]: value,
    };

    if (name === "Vendor_Code") {
      tempArray[index] = {
        ...formState.invoice_Accounts[index],
        vendorCode: value,
      };
    }
    if (name === "wbsElement") {
      let wbsElement = [];
      let tempArr = importPaymentDetail.invoice_Payment_Details;
      for (let i = 0; i < tempArr.length; i++) {
        const element = tempArr[i];
        if (element.rowId === item) {
          element.wbsElement = value;
          wbsElement.push(element);
        } else {
          wbsElement.push(element);
        }
      }
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: wbsElement,
      }));
    }
    if (name === "profitCenter") {
      let profitCenter = [];
      let tempArr = importPaymentDetail.invoice_Payment_Details;

      for (let i = 0; i < tempArr.length; i++) {
        const element = tempArr[i];

        if (element.rowId === item) {
          element.profitCenter = value;
          profitCenter.push(element);
        } else {
          profitCenter.push(element);
        }
      }
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: profitCenter,
      }));
    }
    // if ((formState.isImport || formState.isInitiator) && !formState.pO_Based) {
    if (!formState.pO_Based) {
      if (name === "accountType") {
        let accountTypeArr = [];
        let tempArr = importPaymentDetail.invoice_Payment_Details;
        for (let i = 0; i < tempArr.length; i++) {
          const element = tempArr[i];
          if (element.rowId === item) {
            element.postingKey = value === "Credit" ? "50" : "40";
            accountTypeArr.push(element);
          } else {
            accountTypeArr.push(element);
          }
        }

        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: accountTypeArr,
        }));
      }

      if (name === "glAccount") {
        let glAccountArr = [];
        let tempArr = importPaymentDetail.invoice_Payment_Details;
        for (let i = 0; i < tempArr.length; i++) {
          const element = tempArr[i];
          if (element.rowId === item) {
            element.account = value;
            glAccountArr.push(element);
          } else {
            glAccountArr.push(element);
          }
        }
        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: glAccountArr,
        }));
      }
      if (name === "order") {
        let order = [];
        let tempArr = importPaymentDetail.invoice_Payment_Details;
        for (let i = 0; i < tempArr.length; i++) {
          const element = tempArr[i];
          if (element.rowId === item) {
            element.order = value;
            order.push(element);
          } else {
            order.push(element);
          }
        }
        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: order,
        }));
      }
      if (name === "amount") {
        let amountArr = [];
        let tempArr = importPaymentDetail.invoice_Payment_Details;
        for (let i = 0; i < tempArr.length; i++) {
          const element = tempArr[i];
          if (element.rowId === item) {
            element.amount = value;
            amountArr.push(element);
          } else {
            amountArr.push(element);
          }
        }
        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: amountArr,
        }));
      }
    }

    if (name === "costCenter") {
      getEmployeeByCostCenter_IP(
        () => {},
        // setCostCenterEmployeeLoading,
        value?.CostCenterCode,
        tempArray,
        formState,
        index
      );
      let costCenter = [];
      let tempArr = importPaymentDetail.invoice_Payment_Details;
      for (let i = 0; i < tempArr.length; i++) {
        const element = tempArr[i];
        if (element.rowId === item) {
          element.costCenter = value;
          costCenter.push(element);
        } else {
          costCenter.push(element);
        }
      }
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: costCenter,
      }));
    }
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: tempArray,
    }));
    countHandler(tempArray);
  };

  useEffect(() => {
    if (formState?.invoice_Accounts?.length > 0) {
      let data = [...formState?.invoice_Accounts];
      let tempArr = importPaymentDetail?.invoice_Payment_Details
        ? [...importPaymentDetail?.invoice_Payment_Details]
        : [];
      formState?.invoice_Accounts?.map((item, index) => {
        data[index].stCode = formState?.salesTaxCode?.split(" - ")[0] || "";
        data[index].taxCode = formState?.salesTaxCode?.split(" - ")[0] || "";
        data[index].taxAmount = Number(formState?.salesTaxAmount);
      });
      importPaymentDetail?.invoice_Payment_Details?.map((item, index) => {
        tempArr[index].stCode = formState?.salesTaxCode?.split(" - ")[0] || "";
        tempArr[index].taxCode = formState?.salesTaxCode?.split(" - ")[0] || "";
        if (item.postingKey !== "31") {
          tempArr[index].taxAmount = Number(formState?.salesTaxAmount);
        }
        // tempArr[index].accountType = item.accountType ? item.accountType : item.AccountType ? item.AccountType : "Debit"
      });
      setFormState((formState) => ({ ...formState, invoice_Accounts: data }));
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: tempArr,
      }));
    }
  }, [formState.salesTaxCode, formState.salesTaxAmount]);

  const CostCenterComponent = React.memo(
    ({
      active,
      rowData,
      setRowData,
      focus,
      stopEditing,
      columnData,
      disabled,
    }) => {
      const selectRef = useRef(null);
      const [choices, setChoices] = useState(columnData.choices);
      useEffect(() => {
        if (focus) {
          $(selectRef.current)
            .select2({
              placeholder: "Select Option",
              ajax: {
                url: function (params) {
                  const value = params.term ? params.term : "-1";
                  return `${process.env.REACT_APP_API_URL}/api/Invoices/GetCostCenters_v1/${value}`;
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                  "Content-Type": "application/json",
                },

                processResults: function (data) {
                  setChoices(data);
                  return {
                    results: [{ id: "-1", text: "Select Option" }].concat(
                      data.map((item) => ({
                        id: item.CostCenterCode,
                        text: item.CostCenterCode + "-" + item.Name,
                      }))
                    ),
                  };
                },
              },
            })
            .on("select2:select", function (e) {
              // Get selected value and update cell value
              const selectedValue =
                e.params.data.id === "-1" ? "" : e.params.data.id;
              setRowData(selectedValue);
            });

          // Open Select2 dropdown
          $(selectRef.current).select2("open");
        } else {
          // Destroy Select2 when cell loses focus
          // $(selectRef.current).select2("destroy");
        }
      }, [focus]);

      // useEffect(() => {
      //   getCostCenterData_v2(rowData, setLoading, setChoices);

      //   // getCostCenterDataByID(rowData);
      // }, [rowData]);
      return (
        <>
          {disabled ? (
            <p>
              {rowData} -{" "}
              {choices?.find((x) => x?.CostCenterCode === rowData)?.Name}
            </p>
          ) : (
            <select ref={selectRef} style={{ width: "100%", border: "0px" }}>
              <option value="">Select Option</option>
              {rowData && (
                <option selected>
                  {rowData} -{" "}
                  {choices?.find((x) => x?.CostCenterCode === rowData)?.Name}
                </option>
              )}
            </select>
          )}
          {/* <FormControl fullWidth>
            <Autocomplete
              ref={ref}
              style={{ width: "100%" }}
              disabled={disabled}
              value={
                // Ensure that rowData is an object before trying to access its properties
                rowData
                  ? choices.find(
                      (option) => option.data?.CostCenterCode === rowData
                    ) || {
                      value: "",
                      label: "",
                    }
                  : null
              }
              onChange={(event, newValue) => {
                if (!newValue) {
                  setRowData("");
                } else {
                  const selectedVendor = newValue?.value;
                  setRowData(selectedVendor);
                  setTimeout(stopEditing, 0);
                }

                if (
                  newValue?.data?.IsActive != "True" &&
                  newValue?.data != null
                ) {
                  setAlertMessage(true);
                  setErrAlertMessage("This Cost Center  has been Blocked");
                }
              }}
              options={choices}
              getOptionLabel={(option) => option?.label}
              loading={costCenterLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  size="small"
                  onChange={(event) => {
                    getCostCenterData_v2(
                      event.target.value,
                      setLoading,
                      setChoices
                    );
                  }}
                  // required
                />
              )}
            />
          </FormControl> */}
        </>
      );
    }
  );

  const SelectComponent = React.memo(
    ({
      active,
      rowData,
      setRowData,
      focus,
      stopEditing,
      columnData,
      disabled,
    }) => {
      const selectRef = useRef(null);
      useEffect(() => {
        if (focus) {
          $(selectRef.current)
            .select2({
              placeholder: "Select Option",
              ajax: {
                // url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/`,
                url: function (params) {
                  const value = params.term ? params.term : "-1";
                  return `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${value}`;
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                  "Content-Type": "application/json",
                },
                data: function (params) {
                  return { query: params.term };
                },
                processResults: function (data) {
                  setChoices(data);
                  return {
                    results: [{ id: "-1", text: "Select Option" }].concat(
                      data.map((item) => ({
                        id: item.GLAccount,
                        text: item.GLAccount + "-" + item.ShortText,
                      }))
                    ),
                  };
                },
              },
            })
            .on("select2:select", function (e) {
              // Get selected value and update cell value
              const selectedValue =
                e.params.data.id === "-1" ? "" : e.params.data.id;
              setRowData(selectedValue);
            });

          // Open Select2 dropdown
          $(selectRef.current).select2("open");
        } else {
          // Destroy Select2 when cell loses focus
          // $(selectRef.current).select2("destroy");
        }
      }, [focus]);

      const [choices, setChoices] = useState(columnData.choices || []);

      return (
        <>
          {disabled ? (
            <p>
              {rowData} -{" "}
              {choices?.find((x) => x?.GLAccount === rowData)?.ShortText}
            </p>
          ) : (
            <select ref={selectRef} style={{ width: "100%", border: "0px" }}>
              <option value="">Select Option</option>
              {rowData && (
                <option selected>
                  {rowData} -{" "}
                  {choices?.find((x) => x?.GLAccount === rowData)?.ShortText}
                </option>
              )}
            </select>
          )}
          {/* <option selected> */}
          {/* <FormControl fullWidth>
            <Autocomplete
              ref={ref}
              style={{ width: "100%" }}
              disabled={disabled}
              value={
                // Ensure that rowData is an object before trying to access its properties
                rowData
                  ? choices.find(
                      (option) => option.data?.GLAccount === rowData
                    ) || {
                      value: "",
                      label: "",
                    }
                  : null
              }
              onChange={(event, newValue) => {
                if (!newValue) {
                  setRowData("");
                } else {
                  const selectedVendor = newValue?.value;
                  setRowData(selectedVendor);
                  setTimeout(stopEditing, 0);
                }
                if (
                  newValue?.data?.IsActive != "True" &&
                  newValue?.data != null
                ) {
                  setAlertMessage(true);
                  setErrAlertMessage("This  Gl account  has been Blocked");
                }
              }}
              options={choices}
              getOptionLabel={(option) => option?.label}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  size="small"
                  onChange={(event) => {
                    debugger;
                    getg_laccount_Search(
                      event.target.value,
                      setLoading,
                      setChoices
                    );
                  }}
                  // required
                />
              )}
            />
          </FormControl> */}
        </>
      );
    }
  );

  const DebitCreditComponent = React.memo(
    ({ active, rowData, setRowData, focus, stopEditing, columnData }) => {
      const ref = useRef(null);
      const selectRef = useRef(null);

      useEffect(() => {
        if (focus) {
          ref.current?.focus();
        } else {
          ref.current?.blur();
        }
      }, [focus]);

      const data = [
        {
          id: "Debit",
          text: "Debit",
        },
        {
          id: "Credit",
          text: "Credit",
        },
      ];

      return (
        <>
          {disabled ? (
            <p>{rowData}</p>
          ) : (
            <select
              ref={ref}
              style={{ width: "100%", border: "0px", padding: "6px" }}
              value={rowData}
              onChange={(e) => {
                setRowData(e.target.value);
                ref.current?.blur();
              }}
            >
              <option value="" style={{ padding: "6px" }}>
                Select Option
              </option>
              {data.map((x) => (
                <option
                  style={{ padding: "6px" }}
                  value={x.text}
                  selected={rowData === x.text}
                >
                  {x.text}
                </option>
              ))}
            </select>
            // <select ref={selectRef} style={{ width: "100%", border: "0px" }}>
            //   {rowData && <option selected>{rowData}</option>}
            // </select>
          )}
          {/* <FormControl fullWidth>
            <Autocomplete
              ref={ref}
              style={{ width: "100%" }}
              disabled={disabled}
              value={
                // Ensure that rowData is an object before trying to access its properties
                rowData
                  ? columnData.choices.find(
                      (option) => option.label === rowData
                    )
                  : null
              }
              onChange={(event, newValue) => {
                if (!newValue) {
                  setRowData("");
                } else {
                  const selectedVendor = newValue?.value;
                  setRowData(selectedVendor);
                  setTimeout(stopEditing, 0);
                }
              }}
              options={columnData.choices}
              getOptionLabel={(option) => option?.label}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  size="small"
                  // required
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                />
              )}
            />
          </FormControl> */}
        </>
      );
    }
  );

  const selectColumn = (options) => ({
    component: SelectComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,

    copyValue: ({ rowData }) => rowData,
    // pasteValue: ({ value }) => {
    //   return value;
    // },
    pasteValue: ({ value }) => {
      const paddedValue = value.padStart(10, "0");
      return paddedValue;
    },
  });

  const costselectColumn = (options) => ({
    component: CostCenterComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,
    keepdis: isCostCenterDisabled,

    copyValue: ({ rowData }) => {
      return rowData;
    },
    pasteValue: ({ value }) => {
      return value;
    },
  });

  const debitselectColumn = (options) => ({
    component: DebitCreditComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,

    // copyValue: ({ rowData }) => rowData,
    // pasteValue: ({ value }) => value,
    copyValue: ({ rowData }) => rowData,
    pasteValue: ({ value }) => value,
  });

  const [columns, setColumns] = useState([]);

  // useEffect(() => {

  //     // setGlAccountLoading(true);
   

  //     setColumns(columns_v1);
  //     // setGlAccountLoading(false);
    
  // }, []);
  const columns_v1 = [

    {
      ...keyColumn(
        "accountType" || "AccountType" || " ",
        debitselectColumn({
          choices: [
            { value: "Debit", label: "Debit" },
            { value: "Credit", label: "Credit" },
          ],
        })
      ),
      title: "D/C",
      minWidth: 140,
      disabled: disabled,
    },
    {
      ...keyColumn("glAccount" || "GLAccount" || " ", textColumn),
      // ...keyColumn(
      //   "glAccount" || "GLAccount" || " ",
      //   selectColumn({
      //     choices: glAccount,
      //     // choices: glAccount?.map((account, i) => ({
      //     //   data: account,
      //     //   value: `${account.GLAccount}`,
      //     //   label: `${account.GLAccount} - ${account.ShortText}`,
      //     // })),
      //   })
      // ),

      title: "GL Account",
      minWidth: 340,
      disabled: true,
    },

    {
      ...keyColumn("description" || "Description", textColumn),
      title: "Text",
      minWidth: 360,
      disabled: disabled,
    },
   
    {
      ...keyColumn("amount" || "Amount", floatColumn),
      title: "Amount",
      minWidth: 200,
      disabled: disabled,
      defaultValue: "0",
      pasteValue: ({ rowData, value, rowIndex }) => {
        rowData.amount = Number(value.replace(/,/g, "")) || 0;
        return rowData;
      },
    },
    // {
    //   ...keyColumn("order" || "Order", textColumn),
    //   title: "Order",
    //   minWidth: 160,
    //   disabled: disabled,
    // },
    {
      ...keyColumn("costCenter" || "CostCenter", textColumn),
      // ...keyColumn(
      //   "costCenter" || "CostCenter",
      //   costselectColumn({
      //     choices: costCenterList,
      //     // choices: costCenterList?.map((account, i) => ({
      //     //   data: account,
      //     //   value: `${account.CostCenterCode}`,
      //     //   label: `${account.CostCenterCode} - ${account.Name}`,
      //     // })),
      //   })
      // ),
      title: "Cost Center",
      minWidth: 340,
      disabled: true,
      // disabled: ({ rowData }) => {
      //   if (rowData?.profitCenter || disabled) {
      //     return true;
      //   }
      //   return false;
      // },
    },
    {
      ...keyColumn("CostCenterOwnerName", textColumn),
      title: "CC owner",
      minWidth: 300,
      disabled: true,
    },
    // {
    //   ...keyColumn("stCode" || "STCode", textColumn),
    //   title: "St Code",
    //   isCellEmpty: (props) => {
    //     return false;
    //   },
    //   disabled: disabled,
    // },
    {
      ...keyColumn("profitCenter" || "ProfitCenter", intColumn),
      title: "Profit Center",
      disabled: ({ rowData }) => {
        if (rowData?.costCenter || disabled) {
          return true;
        }
        return false;
      },
    },
    {
      ...keyColumn("wbsElement" || "WBSElement", textColumn),
      title: "WBS Element",
      minWidth: 140,
      disabled: ({ rowData }) => {
        if (rowData?.costCenter || disabled) {
          return true;
        }
        return false;
      },
    },
   
  ];
  const pasteDataInGrid = (operation, columnName, data) => {
    const tempArrayStr = JSON.stringify(formState.invoice_Accounts);
    const tempArray = JSON.parse(tempArrayStr);

    let pasteDataIndex = 0;
    let newpaymentDetails = importPaymentDetail?.invoice_Payment_Details;
    // for update

    const toIndex = operation?.[1]?.toRowIndex
      ? operation?.[1]?.toRowIndex
      : operation?.[0]?.toRowIndex;

    if (operation[0]?.type) {
      for (let index = operation?.[0].fromRowIndex; index < toIndex; index++) {
        const randomNum = Math.random();
        const findedPayDetail = newpaymentDetails.find(
          (x) => x?.rowId === (formState.invoice_Accounts?.[index]?.rowId || "")
        );
        //  add payment detail for update.
        if (findedPayDetail) {
          const findedPayDetailIndex = newpaymentDetails.findIndex(
            (x) => x?.rowId === formState.invoice_Accounts?.[index]?.rowId
          );
          if (columnName !== "accountType") {
            newpaymentDetails[findedPayDetailIndex][`${columnName}`] =
              data[pasteDataIndex]?.[`${columnName}`];
          } else {
            newpaymentDetails[findedPayDetailIndex].postingKey =
              data[pasteDataIndex]?.[`${columnName}`] === "Credit"
                ? "50"
                : "40";
          }
        } else {
          // new payment detail for create.
          if (
            (formState?.isImport && !formState?.pO_Based) ||
            (formState?.isVPPayment && !formState?.pO_Based) ||
            !formState?.pO_Based
          ) {
            const stringify = JSON.stringify(invoice_Payment_Details);
            const parseinvoice_Payment_Details = JSON.parse(stringify);
            parseinvoice_Payment_Details.rowId = randomNum;

            if (columnName !== "accountType") {
              parseinvoice_Payment_Details[`${columnName}`] =
                data[pasteDataIndex]?.[`${columnName}`];
            } else {
              parseinvoice_Payment_Details.postingKey =
                data[pasteDataIndex]?.[`${columnName}`] === "Credit"
                  ? "50"
                  : "40";
            }
            newpaymentDetails.push(parseinvoice_Payment_Details);
          }
        }

        tempArray[index] = {
          ...formState.invoice_Accounts[index],
          [columnName]: data[pasteDataIndex]?.[columnName],
          rowId: formState.invoice_Accounts?.[index]?.rowId || randomNum,
        };
        pasteDataIndex++;
      }
    }

    setImportPaymentDetail((importPaymentDetail) => ({
      ...importPaymentDetail,
      invoice_Payment_Details: newpaymentDetails,
    }));

    setFormState((formState) => ({
      ...formState,
      invoice_Accounts: tempArray,
    }));
  };

  const handleGridChange = async (data, operation, rowKey) => {
    const index = operation[0]?.fromRowIndex;
    const firstOperation =
      operation?.[0]?.toRowIndex - operation?.[0]?.fromRowIndex;
    const secondOperation =
      operation?.[1]?.toRowIndex - operation?.[1]?.fromRowIndex;

    const noOfColumns = firstOperation + Number(secondOperation || 0);
    if (noOfColumns > 1) {
      // Call the function only for paste operations
      if (activeCell === "glAccount") {
        if (data[index]?.glAccount) {
          setActiveCell("");
          setColumns([]);
          await getg_laccountForCopyPast(
            formState,
            operation,
            data,
            invoice_Payment_Details,
            importPaymentDetail,
            setImportPaymentDetail,
            setFormState,
            setGlAccountLoading,
            setGlAccount
          );
        }
      }
      if (activeCell === "costCenter") {
        if (data[index]?.costCenter) {
          setColumns([]);
          await getCostCenterForCopyPast(
            formState,
            operation,
            data,
            invoice_Payment_Details,
            importPaymentDetail,
            setImportPaymentDetail,
            setFormState,
            setCostCenterLoading,
            setCostCenterList
          );
        }
      }
      if (activeCell === "amount") {
        pasteDataInGrid(operation, "amount", data);
      }
      if (activeCell === "order") {
        pasteDataInGrid(operation, "order", data);
      }
      if (activeCell === "stCode") {
        pasteDataInGrid(operation, "stCode", data);
      }
      if (activeCell === "profitCenter") {
        pasteDataInGrid(operation, "profitCenter", data);
      }
      if (activeCell === "wbsElement") {
        pasteDataInGrid(operation, "wbsElement", data);
      }
      if (activeCell === "description") {
        pasteDataInGrid(operation, "description", data);
      }
      if (activeCell === "accountType") {
        pasteDataInGrid(operation, "accountType", data);
      }
    } else {
      if (operation[0].type === "CREATE") {
        const num = Math.random();
        invoice_Payment_Details.rowId = num;
        invoice_Payment_Details.taxCode = formState?.salesTaxCode;
        tableData.rowId = num;
        setFormState((formState) => ({
          ...formState,
          invoice_Accounts: [...formState?.invoice_Accounts, tableData],
        }));
        if (
          (formState?.isImport && !formState?.pO_Based) ||
          (formState?.isVPPayment && !formState?.pO_Based) ||
          !formState?.pO_Based
        ) {
          setImportPaymentDetail((importPaymentDetail) => ({
            ...importPaymentDetail,
            invoice_Payment_Details: [
              ...importPaymentDetail?.invoice_Payment_Details,
              invoice_Payment_Details,
            ],
          }));
        }
      } else if (operation[0].type === "DELETE") {
        debugger;
        const filteredData = formState?.invoice_Accounts?.filter(
          (x, i) => i !== index
        );
        const finded = formState?.invoice_Accounts?.find((x, i) => i !== index);
        setFormState((formState) => ({
          ...formState,
          invoice_Accounts: filteredData,
        }));

        const filteredPaymentDetail =
          importPaymentDetail?.invoice_Payment_Details?.filter(
            (x, i) => x?.rowId !== formState?.invoice_Accounts[index]?.rowId
          );
        // if (formState?.isImport) {
        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: filteredPaymentDetail,
        }));
        // }
        countHandler(filteredData);
      } else if (operation[0].type === "UPDATE") {
        if (data[index]?.wbsElement && activeCell === "wbsElement") {
          let wbsElement = [];
          let tempArr = importPaymentDetail.invoice_Payment_Details;
          for (let i = 0; i < tempArr.length; i++) {
            const element = tempArr[i];
            if (element.rowId === data[index].rowId) {
              element.wbsElement = data[index].wbsElement;
              wbsElement.push(element);
            } else {
              wbsElement.push(element);
            }
          }
          setImportPaymentDetail((importPaymentDetail) => ({
            ...importPaymentDetail,
            invoice_Payment_Details: wbsElement,
          }));
        }
        if (data[index]?.profitCenter && activeCell === "profitCenter") {
          let profitCenter = [];
          let tempArr = importPaymentDetail.invoice_Payment_Details;

          for (let i = 0; i < tempArr.length; i++) {
            const element = tempArr[i];

            if (element.rowId === data[index].rowId) {
              element.profitCenter = data[index].profitCenter;
              // element.profitCenter = data[index].profitCenter.toString();

              profitCenter.push(element);
            } else {
              profitCenter.push(element);
            }
          }
          setImportPaymentDetail((importPaymentDetail) => ({
            ...importPaymentDetail,
            invoice_Payment_Details: profitCenter,
          }));
        }
        // // if ((formState.isImport || formState.isInitiator) && !formState.pO_Based) {
        if (!formState.pO_Based) {
          if (data[index]?.accountType && activeCell === "accountType") {
            let accountTypeArr = [];
            let tempArr = importPaymentDetail.invoice_Payment_Details;
            for (let i = 0; i < tempArr.length; i++) {
              const element = tempArr[i];
              if (element.rowId === data[index]?.rowId) {
                element.postingKey =
                  data[index]?.accountType === "Credit" ? "50" : "40";
                accountTypeArr.push(element);
              } else {
                accountTypeArr.push(element);
              }
            }
            debugger;
            setImportPaymentDetail((importPaymentDetail) => ({
              ...importPaymentDetail,
              invoice_Payment_Details: accountTypeArr,
            }));
          }

          if (data[index]?.glAccount && activeCell === "glAccount") {
            const ab = { Vendor: "" };
            await getg_laccount_Search(data[index]?.glAccount, setLoading, ab);
            let glAccountArr = [];
            let tempArr = importPaymentDetail.invoice_Payment_Details;
            for (let i = 0; i < tempArr.length; i++) {
              const element = tempArr[i];
              if (element.rowId === data[index]?.rowId) {
                element.account = data[index]?.glAccount;
                element.accountName = ab?.Vendor?.ShortText;
                glAccountArr.push(element);
              } else {
                glAccountArr.push(element);
              }
            }
            setImportPaymentDetail((importPaymentDetail) => ({
              ...importPaymentDetail,
              invoice_Payment_Details: glAccountArr,
            }));
          }
          if (data[index]?.order && activeCell === "order") {
            let order = [];
            let tempArr = importPaymentDetail.invoice_Payment_Details;
            for (let i = 0; i < tempArr.length; i++) {
              const element = tempArr[i];
              if (element.rowId === data[index]?.rowId) {
                element.order = data[index]?.order;
                order.push(element);
              } else {
                order.push(element);
              }
            }
            setImportPaymentDetail((importPaymentDetail) => ({
              ...importPaymentDetail,
              invoice_Payment_Details: order,
            }));
          }
          if (data[index]?.amount && activeCell === "amount") {
            let amountArr = [];
            let tempArr = importPaymentDetail.invoice_Payment_Details;
            for (let i = 0; i < tempArr.length; i++) {
              const element = tempArr[i];
              if (element.rowId === data[index]?.rowId) {
                element.amount = Number(
                  Number(data[index]?.amount)?.toFixed(2)
                );
                amountArr.push(element);
              } else {
                amountArr.push(element);
              }
            }
            setImportPaymentDetail((importPaymentDetail) => ({
              ...importPaymentDetail,
              invoice_Payment_Details: amountArr,
            }));
          }
          if (data[index]?.description && activeCell === "order") {
            let descriptionArr = [];
            let tempArr = importPaymentDetail.invoice_Payment_Details;
            for (let i = 0; i < tempArr.length; i++) {
              const element = tempArr[i];
              if (element.rowId === data[index]?.rowId) {
                element.description = data[index]?.description;
                descriptionArr.push(element);
              } else {
                descriptionArr.push(element);
              }
            }
            setImportPaymentDetail((importPaymentDetail) => ({
              ...importPaymentDetail,
              invoice_Payment_Details: descriptionArr,
            }));
          }
        }

        if (data[index]?.costCenter && activeCell === "costCenter") {
          let costCenter = [];
          let tempArr = importPaymentDetail.invoice_Payment_Details;
          for (let i = 0; i < tempArr.length; i++) {
            const element = tempArr[i];
            if (element.rowId === data[index]?.rowId) {
              element.costCenter = data[index]?.costCenter;
              costCenter.push(element);
            } else {
              costCenter.push(element);
            }
          }
          setImportPaymentDetail((importPaymentDetail) => ({
            ...importPaymentDetail,
            invoice_Payment_Details: costCenter,
          }));
        }

        if (data[index]?.costCenter && activeCell === "costCenter") {
          let updatedData = [];
          for (let j = 0; j < data.length; j++) {
            const row = data[j];

            let ab = { costCenterData: "" };

            if (row?.costCenter) {
              await getEmployeeByCostCenter(row?.costCenter, setLoading, ab);
            }

            row.costCenterOwner = row?.costCenter
              ? ab.costCenterData.employeeCode
                ? ab.costCenterData.employeeCode
                : "No Found"
              : "";
            row.CostCenterOwnerName = row?.costCenter
              ? ab.costCenterData.employeeName
                ? ab.costCenterData.employeeName
                : "Not Found"
              : "";
            updatedData.push(row);
          }

          setFormState((formState) => ({
            ...formState,
            invoice_Accounts: updatedData,
          }));
        } else {
          setFormState((formState) => ({
            ...formState,
            invoice_Accounts: data,
          }));
        }
        countHandler(data);
      }
    }
  };

  const calculateTotalGLAmount = () => {
    const totalGLAmount = formState?.invoice_Accounts?.reduce(
      (accumulator, currentValue) => {
        const amountWithoutCommas = String(currentValue?.amount).replace(
          /,/g,
          ""
        );
        const numericAmount = Number(Number(amountWithoutCommas)?.toFixed(2));
  
        if (currentValue?.accountType === 'Debit') {
          return accumulator + numericAmount; 
        } else if (currentValue?.accountType === 'Credit') {
          return accumulator - numericAmount;  
        }
        return accumulator; 
      },
      0
    );
  
    return Math.abs(totalGLAmount);
  };
  const totalAmount = calculateTotalGLAmount();

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ width: "0", overflowX: "auto" }}
      >
        <>
          {/*   <TableContainer>
          <Table
            aria-label="simple table"
            className={classes.table}
            size="small"
          >
            <TableHead>
              <TableRow
                sx={{ backgroundColor: "#EFF2F4", width: "100%" }}
                // style={{ width: "100%" }}
              >
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30", width: "10%" }}
                >
                  GL Account
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  D/C
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  // style={{ width: "11%" }}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    color: "#031C30",
                    // width: "11%",
                  }}
                >
                  Order
                </TableCell>

                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  // style={{ width: "11%" }}
                >
                  Cost Cent
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  // style={{ width: "11%" }}
                >
                  CC Owner
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  // style={{ width: "11%" }}
                >
                  ST Code
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  // style={{ width: "11%" }}
                >
                  Profit Cent
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  // style={{ width: "11%" }}
                >
                  WBS Element
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  // style={{ width: "11%" }}
                >
                  Text
                </TableCell>
                {!disabled && (
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#031C30",
                    }}
                  >
                    Action
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {formState?.invoice_Accounts?.length > 0 &&
                formState?.invoice_Accounts?.map((item, index) => {
                  return (
                    <TableRow>
                      <TableCell scope="row" sx={{ padding: "10px" }}>
                        <FormControl fullWidth size="small">
                          <GetChargeAccount
                            GLAccount={item?.glAccount || item?.GLAccount}
                            item={item}
                            changeHandler={changeHandler}
                            index={index}
                            disabled={disabled}
                            bordered={false}
                            setAlertMessage={setAlertMessage}
                            setErrAlertMessage={setErrAlertMessage}
                          />
                        </FormControl>
                      </TableCell>

                      <TableCell sx={{ padding: "10px" }}>
                        <FormControl
                          fullWidth
                          size="small"
                          required={
                            (item?.glAccount || item?.GLAccount) &&
                            (item?.amount || item?.Amount)
                          }
                        >
                          <Select
                            variant="standard"
                            value={
                              item?.accountType
                                ? item?.accountType
                                : item?.AccountType
                                ? item?.AccountType
                                : ""
                            }
                            name="accountType"
                            placeholder="Select a Value"
                            onChange={(e) =>
                              changeHandler(e, index, item.rowId)
                            }
                            disabled={disabled}
                            displayEmpty
                            className={classes.selectEmpty}

                            // disableUnderline
                          >
                            {[
                              { accountType: "Credit" },
                              { accountType: "Debit" },
                            ].map((x) => (
                              <MenuItem value={x?.accountType}>
                                {x?.accountType}
                              </MenuItem>
                            ))}
                          </Select>
                   
                        </FormControl>
                      </TableCell>
                      {<TextField
                          // fullWidth
                          type="number"
                          size="small"
                          name="accountType"
                          value={item?.accountType || item?.AccountType}
                          disabled={disabled}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            padding:"6px"
                          }}
                          inputProps={{ inputProps: { min: 0, step: "0.001" } }}
                          onChange={(event) => changeHandler(event, index)}
                          id="outlined-basic"
                          variant="standard"
                        /> }
                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          // fullWidth
                          type="number"
                          size="small"
                          name="amount"
                          value={item?.amount || item?.Amount}
                          disabled={disabled}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          onChange={(event) =>
                            changeHandler(event, index, item?.rowId)
                          }
                          id="outlined-basic"
                          variant="standard"
                          // InputProps ={{disableUnderline : true}}
                        />
                      </TableCell>
                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          // fullWidth
                          type="text"
                          size="small"
                          name="order"
                          value={item?.order || item?.Order}
                          disabled={disabled}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          onChange={(e) => changeHandler(e, index, item.rowId)}
                          id="outlined-basic"
                          variant="standard"
                          required={
                            (item?.glAccount || item?.GLAccount) &&
                            (item?.amount || item?.Amount)
                          }
                          // InputProps ={{disableUnderline : true}}
                        />
                      </TableCell>
                      <TableCell sx={{ padding: "6px" }}>
                        <FormControl fullWidth size="small">
                          <CostCenter
                            value={
                              item?.costCenter ||
                              item?.CostCenter || {
                                CostCenterCode: "",
                                Name: "",
                              }
                            }
                            costCenter={item?.costCenter || ""}
                            changeHandler={changeHandler}
                            index={index}
                            disabled={
                              !disabled
                                ? item?.profitCenter
                                  ? true
                                  : false
                                : disabled
                            }
                            bordered={false}
                            row={item.rowId}
                            setAlertMessage={setAlertMessage}
                            setErrAlertMessage={setErrAlertMessage}
                          />
                        </FormControl>
                      </TableCell>

                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          disabled
                          type="text"
                          size="small"
                          variant="standard"
                          // InputProps ={{disableUnderline : true}}

                          style={{ width: "200" }}
                          fullWidth
                          value={`${
                            item?.costCenterOwner || item?.CostCenterOwner || ""
                          } ${
                            item?.costCenterOwnerName ||
                            item?.CostCenterOwnerName
                              ? "-"
                              : ""
                          } ${
                            item?.costCenterOwnerName ||
                            item?.CostCenterOwnerName ||
                            ""
                          }`}
                        ></TextField>

                      </TableCell>
                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          // fullWidth
                          type="text"
                          size="small"
                          name="stCode"
                          value={item?.stCode || item?.STCode}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          disabled={disabled}
                          onChange={(event) =>
                            changeHandler(event, index, item.rowId)
                          }
                          id="outlined-basic"
                          variant="standard"
                          required={
                            (item?.glAccount || item?.GLAccount) &&
                            (item?.amount || item?.Amount)
                          }
                          // InputProps ={{disableUnderline : true}}
                        />
                      </TableCell>
                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          type="number"
                          name="profitCenter"
                          size="small"
                          value={item?.profitCenter || item?.ProfitCenter}
                          disabled={
                            !disabled
                              ? item?.costCenter
                                ? true
                                : false
                              : disabled
                          }
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="standard"
                          // InputProps ={{disableUnderline : true}}

                          onChange={(event) =>
                            changeHandler(event, index, item.rowId)
                          }
                          required={
                            (item?.glAccount || item?.GLAccount) &&
                            (item?.amount || item?.Amount)
                          }
                        />
                      </TableCell>
                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          type="text"
                          name="wbsElement"
                          size="small"
                          value={item?.wbsElement || item?.WBSElement}
                          // value={`${
                          //   item?.wbsElement || item?.WBSElement || ""
                          // } - ${
                          //   item?.costCenterOwnerName ||
                          //   item?.CostCenterOwnerName ||
                          //   ""
                          // }`}
                          disabled={
                            !disabled
                              ? item?.costCenter
                                ? true
                                : false
                              : disabled
                          }
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="standard"
                          // InputProps ={{disableUnderline : true}}
                          required={
                            (item?.glAccount || item?.GLAccount) &&
                            (item?.amount || item?.Amount)
                          }
                          onChange={(event) =>
                            changeHandler(event, index, item.rowId)
                          }
                        />
                      </TableCell>
                      <TableCell sx={{ padding: "10px" }}>
                        <TextField
                          // fullWidth
                          type="text"
                          size="small"
                          name="description"
                          value={item?.description || item?.Description}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          disabled={disabled}
                          onChange={(event) =>
                            changeHandler(event, index, item.rowId)
                          }
                          required={
                            (item?.glAccount || item?.GLAccount) &&
                            (item?.amount || item?.Amount)
                          }
                          id="outlined-basic"
                          variant="standard"
                          // InputProps ={{disableUnderline : true}}
                        />
                      </TableCell>
                      {!disabled && (
                        <TableCell align="center">
                          <Delete
                            color="error"
                            onClick={() => {
                              deleteInput(index, item?.rowId);
                            }}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
            {!formState?.invoice_Accounts && (
              <TableSkeleton noOfColumns={11} noOfLines={3} />
            )}
          </Table>
          {formState?.invoice_Accounts.length === 0 && <EmptyData />}

          <Grid container spacing={0} mt={1}>
            <Grid item sm={6} md={3} lg={1}>
              <b>Total GL Amount:</b>
            </Grid>
            <Grid item sm={6} md={3} lg={2} style={{ paddingLeft: "4px" }}>
              <b>
                {addZeroes(
                  formState?.invoice_Accounts
                    ?.map((data) => data.amount)
                    .reduce((prev, curr) => Number(prev) + Number(curr), 0)
                )}
              </b>
            </Grid>
          </Grid>
        </TableContainer>*/}
        </>

        <DataSheetGrid
          style={{
            "--dsg-header-text-color": "#031C30",
          }}
          value={[
            ...formState?.invoice_Accounts?.map((item) => {
              const newItem = { ...item };
              if (newItem.hasOwnProperty("amount")) {
                newItem["amount"] = Number(
                  Number(newItem["amount"])?.toFixed(2)
                );
              } else if (newItem.hasOwnProperty("Amount")) {
                newItem["Amount"] = Number(
                  Number(newItem["Amount"])?.toFixed(2)
                );
              }
              return newItem;
            }),
          ]}
          // value={ formState?.invoice_Accounts}
          onActiveCellChange={({ cell }) => {
            setActiveCell(cell?.colId || "");
          }}
          // onSelectionChange={(res) => {
          // }}
          onChange={handleGridChange}
          columns={columns_v1}
          lockRows={!disabled ? false : true}

          // onDelete={handleDelete}
        />

        {/* <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
            <LinearProgress color="info" />
            <LinearProgress color="info" />
            <LinearProgress color="info" />
          </Stack> */}
        <Grid container spacing={0} mt={1}>
          <Grid item sm={6} md={3} lg={1}>
            <b>Total GL Amount:</b>
          </Grid>
          <Grid item sm={6} md={3} lg={2} style={{ paddingLeft: "4px" }}>
            <b>
              {totalAmount?.toLocaleString()}
              {/* {addZeroes(
                formState?.invoice_Accounts
                  ?.map((data) => data.amount)
                  .reduce((prev, curr) => Number(prev) + Number(curr), 0)
              )} */}
            </b>
          </Grid>
        </Grid>
        {/* {!disabled && (
          <Box display="flex" justifyContent={"flex-end"} mt={2}>
            <Button color="secondary" variant="contained" onClick={addInput}>
              Add New Row
            </Button>
          </Box>
        )} */}
        {alertMessage && (
          <POAlertDialog
            setAlertMessage={setAlertMessage}
            message={erralertMessage}
            setErrAlertMessage={() => {}}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default GL_Table_ProcessInvoice;
